import { useCallback } from "react"

import { useRole } from 'Pods/ItemPage/TopSection/hooks/useTopSectionProps'
import usePageConfig from 'Pods/Shared/Hooks/usePageConfig'

export default function usePermissions({ useCases, currentUsername }) {
  const role = useRole()
  const pageConfig = usePageConfig()

  const isBuyerWithoutAnUseCase =
    role === 'buyer' && !useCases.some((useCase) => useCase.username === currentUsername)

  const isBuyerWithAnUseCase = role === 'buyer' && useCases.some((useCase) => useCase.username === currentUsername)


  const isFreeModel = pageConfig?.product?.price === 0
  const isUser = role === 'user'
  const isDownloaded = pageConfig?.product?.isDownloaded || false
  const isUserWithFreeModelDownload = isUser && isFreeModel && isDownloaded

  const userHavePermissions = role === 'seller' || isBuyerWithoutAnUseCase || isUserWithFreeModelDownload

  const canUseLikeFeature = ['buyer', 'seller', 'user'].includes(role)

  const canDeleteUseCase = useCallback(
    (useCase) => {
      if (!useCase) return false
      if (!currentUsername) return false

      const isAdmin = Boolean(pageConfig?.currentUserIsAdmin)
      if (isAdmin) return true

      const isOwner = useCase.username === currentUsername
      const isSeller = role === 'seller'
      const isAccepted = useCase.status === 'accepted'

      if (isSeller && isAccepted) {
        return true
      }

      return isOwner && isAccepted
    },
    [currentUsername, role, pageConfig]
  )

  const canEditUseCase = useCallback((username) => {
    if (!currentUsername) return false
    return username === currentUsername
  }, [currentUsername])

  return {
    canDeleteUseCase,
    canEditUseCase,
    canUseLikeFeature,
    isBuyerWithAnUseCase,
    isBuyerWithoutAnUseCase,
    userHavePermissions,
    isFreeModel,
    isDownloaded,
  }
}
